// extracted by mini-css-extract-plugin
export var textInput = "_je-0";